export default "__VITE_ASSET__DfKJBwbJ__"